import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminComponent } from './components/admin/admin.component';
import { ChampionAndPichichiComponent } from './components/champion-and-pichichi/champion-and-pichichi.component';
import { CommunicationDetailComponent } from './components/communications/communication-detail/communication-detail.component';
import { CommunicationsListComponent } from './components/communications/communications-list/communications-list.component';
import { EmailTemplateEditComponent } from './components/email-templates/email-template-edit/email-template-edit.component';
import { EmailTemplatesListComponent } from './components/email-templates/email-templates-list/email-templates-list.component';
import { FinalResultComponent } from './components/final-result/final-result.component';
import { GroupsComponent } from './components/groups/groups.component';
import { GroupDetailComponent } from './components/group-detail/group-detail.component';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { MatchesComponent } from './components/matches/matches.component';
import { PollComponent } from './components/poll/poll.component';
import { ProfileComponent } from './components/profile/profile.component';
import { RestoreComponent } from './components/restore/restore.component';
import { RoundSummariesComponent } from './components/round-summaries/round-summaries.component';
import { RulesComponent } from './components/rules/rules.component';
import { SignupComponent } from './components/signup/signup.component';
import { StandingsComponent } from './components/standings/standings.component';
import { StatsEvolutionComponent } from './components/stats-evolution/stats-evolution.component';
import { StatsBadgesComponent } from './components/stats-badges/stats-badges.component';
import { StatsScorersComponent } from './components/stats-scorers/stats-scorers.component';
import { StatsGroupStandingsComponent } from './components/stats-group-standings/stats-group-standings.component';
import { StatsSnipersComponent } from './components/stats-snipers/stats-snipers.component';
import { StatsComponent } from './components/stats/stats.component';
import { UsersComponent } from './components/users/users.component';
import { WhatsAppStatusComponent } from './components/whatsapp-status/whatsapp-status.component';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: StandingsComponent,
    canActivate: [AuthGuard],
  },

  { path: 'login', component: LoginComponent },
  { path: 'register', component: SignupComponent },
  { path: 'restore', component: RestoreComponent },
  { path: 'restore/:token', component: RestoreComponent },

  { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'home/:id', component: HomeComponent, canActivate: [AuthGuard] },
  {
    path: 'standings',
    component: StandingsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'stats',
    component: StatsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'stats/evolution',
    component: StatsEvolutionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'stats/snipers',
    component: StatsSnipersComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'stats/badges',
    component: StatsBadgesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'stats/scorers',
    component: StatsScorersComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'stats/group-standings',
    component: StatsGroupStandingsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'groups/:id',
    component: GroupDetailComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'poll',
    component: PollComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'poll/:id',
    component: PollComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'champion',
    component: ChampionAndPichichiComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'champion/:id',
    component: ChampionAndPichichiComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/matches',
    component: MatchesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/users',
    component: UsersComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/users/:id',
    component: ProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/groups',
    component: GroupsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/email-templates',
    component: EmailTemplatesListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/email-templates/:key',
    component: EmailTemplateEditComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/communications',
    component: CommunicationsListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/communications/:id',
    component: CommunicationDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/final-result',
    component: FinalResultComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/round-summaries',
    component: RoundSummariesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/whatsapp',
    component: WhatsAppStatusComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'rules',
    component: RulesComponent,
    canActivate: [AuthGuard],
  },

  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
